"use strict";
//tslint:disable
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var bpMap = {
    A: "T", a: "t",
    T: "A", t: "a",
    C: "G", c: "g",
    G: "C", g: "c",
};
function reverseCompliant(read, reverse, compliant) {
    var result;
    if (compliant) {
        result = _.map(read, function (x) { return bpMap[x]; }).join("");
    }
    else {
        result = read;
    }
    if (reverse) {
        result = result.split("").reverse().join("");
    }
    return result;
}
exports.reverseCompliant = reverseCompliant;
function setLocalStorage(key, value, encode) {
    if (encode === void 0) { encode = false; }
    if (window.localStorage) {
        if (encode) {
            value = JSON.stringify(value);
        }
        try {
            localStorage.setItem(key, value);
        }
        catch (e) {
            console.warn(e);
        }
    }
    else {
        console.warn("BVD3: No local storage support! Some settings will not be saved.");
    }
}
exports.setLocalStorage = setLocalStorage;
function getLocalStorage(key, defaultVal, encode) {
    if (defaultVal === void 0) { defaultVal = null; }
    if (encode === void 0) { encode = false; }
    if (window.localStorage) {
        var val = localStorage.getItem(key);
        if (encode) {
            val = JSON.parse(val);
        }
        return val === undefined || val === null ? defaultVal : val;
    }
    else {
        console.warn("BVD3: No local storage support! Some settings will not be saved.");
    }
}
exports.getLocalStorage = getLocalStorage;
function deleteIf(array, cond) {
    var i = array.length;
    while (i--) {
        if (cond(array[i], i)) {
            array.splice(i, 1);
        }
    }
}
exports.deleteIf = deleteIf;
function moveElement(array, oldIndex, newIndex) {
    if (newIndex >= array.length) {
        newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array;
}
exports.moveElement = moveElement;
function scale(x, y) {
    return "scale(" + x + "," + y + ")";
}
exports.scale = scale;
function translate(x, y) {
    return "translate(" + x + "," + y + ")";
}
exports.translate = translate;
function translateFromPadding(x) {
    return "translate(" + x.l + "," + x.t + ")";
}
exports.translateFromPadding = translateFromPadding;
function rotate(x) {
    return "rotate(" + x + ")";
}
exports.rotate = rotate;
function rotateWithOrigin(deg, cx, cy) {
    return "rotate(" + deg + "," + cx + "," + cy + ")";
}
exports.rotateWithOrigin = rotateWithOrigin;
function str2color(str) {
    return "#aaa";
}
exports.str2color = str2color;
function constrain(num, min, max) {
    if (num > max) {
        return max;
    }
    else if (num < min) {
        return min;
    }
    else {
        return num;
    }
}
exports.constrain = constrain;
function mutationDesciption(mut) {
    if (mut.type === "snp") {
        return mut.origAllele.toUpperCase() + "\n                <i class=\"fa fa-angle-right\"></i>\n                " + mut.allele.toUpperCase();
    }
    else if (mut.type === "del") {
        return "Deleted " + mut.allele.toUpperCase();
    }
    else if (mut.type === "ins") {
        return "Inserted " + mut.allele.toUpperCase();
    }
    else if (mut.type === "integ") {
        return "(Integrated) " + mut.allele.toUpperCase();
    }
    else {
        return "";
    }
}
exports.mutationDesciption = mutationDesciption;
function getTickScale(thick) {
    function baseOf(n) {
        var count = 1;
        if (n >= 1) {
            while (n / 10 >= 1) {
                n /= 10;
                count *= 10;
            }
        }
        else if (n > 0) {
            while (n * 10 <= 1) {
                n *= 10;
                count /= 10;
            }
        }
        else {
            return 0;
        }
        return count;
    }
    var base = baseOf(thick);
    return _.minBy([base, base * 2, base * 5].map(function (x) { return [x, Math.abs(base - x)]; }), function (x) { return x[1]; })[0];
}
exports.getTickScale = getTickScale;
function polar2cart(angle, radius) {
    var a = (angle - 90) / 180 * Math.PI;
    return [Math.cos(a) * radius, Math.sin(a) * radius];
}
exports.polar2cart = polar2cart;
function toRad(angle) {
    return angle * Math.PI / 180;
}
exports.toRad = toRad;
function toDeg(angle) {
    return angle * 180 / Math.PI;
}
exports.toDeg = toDeg;
function addParameter(parameterName, parameterValue, atStart) {
    var url = window.location.href;
    var replaceDuplicates = true;
    var urlhash;
    var sourceUrl;
    var cl;
    if (url.indexOf("#") > 0) {
        cl = url.indexOf("#");
        urlhash = url.substring(url.indexOf("#"), url.length);
    }
    else {
        urlhash = "";
        cl = url.length;
    }
    sourceUrl = url.substring(0, cl);
    var urlParts = sourceUrl.split("?");
    var newQueryString = "";
    if (urlParts.length > 1) {
        var parameters = urlParts[1].split("&");
        for (var i = 0; (i < parameters.length); i++) {
            var parameterParts = parameters[i].split("=");
            if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
                if (newQueryString === "") {
                    newQueryString = "?";
                }
                else {
                    newQueryString += "&";
                }
                newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : "");
            }
        }
    }
    if (newQueryString === "") {
        newQueryString = "?";
    }
    if (atStart) {
        newQueryString = "?" + parameterName + "=" + parameterValue +
            (newQueryString.length > 1 ? "&" + newQueryString.substring(1) : "");
    }
    else {
        if (newQueryString !== "" && newQueryString !== "?") {
            newQueryString += "&";
        }
        newQueryString += parameterName + "=" + (parameterValue ? parameterValue : "");
    }
    history.pushState({}, document.title, urlParts[0] + newQueryString + urlhash);
}
exports.addParameter = addParameter;
function removeParameter(key) {
    var sourceURL = window.location.href;
    var rtn = sourceURL.split("?")[0];
    var param;
    var paramsArr = [];
    var queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        paramsArr = queryString.split("&");
        for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
            param = paramsArr[i].split("=")[0];
            if (param === key) {
                paramsArr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + paramsArr.join("&");
    }
    history.pushState({}, document.title, rtn);
}
exports.removeParameter = removeParameter;
function getParameter(name) {
    var match = location.search.match(RegExp("[?&]" + name + "=(.+?)(&|$)"));
    if (match) {
        return [true, match[1]];
    }
    else {
        return [false, null];
    }
}
exports.getParameter = getParameter;
var letterWidth = {
    12: 5,
};
function stringLength(str, fontSize) {
    if (typeof letterWidth[fontSize] === "number") {
        return str.length * letterWidth[fontSize];
    }
    else {
        console.error("Error: Cannot calculate string length with a undefined font size!");
    }
}
exports.stringLength = stringLength;
function isBrightColor(color) {
    var parsedColor = d3.color(color).rgb();
    return parsedColor.r + parsedColor.g + parsedColor.b >= 382;
}
exports.isBrightColor = isBrightColor;
function toHexColor(color) {
    var c = d3.color(color).rgb();
    var str = "#";
    ["r", "g", "b"].forEach(function (com) {
        var hex = c[com].toString(16);
        if (hex.length === 1) {
            hex = "0" + hex;
        }
        str += hex;
    });
    return str;
}
exports.toHexColor = toHexColor;
var arc = d3.arc();
function generateArc(args) {
    return arc(args).match(/M(.+?)A(.+?)(?=A)/)[0];
}
exports.generateArc = generateArc;
function formatFileSize(fileSize) {
    var sizes = [[1000000000, "G"], [1000000, "M"], [1000, "K"]];
    for (var _i = 0, sizes_1 = sizes; _i < sizes_1.length; _i++) {
        var s = sizes_1[_i];
        if (fileSize > s[0]) {
            return (Math.floor(100 * fileSize / s[0]) / 100) + s[1] + "B";
        }
    }
    return fileSize + "B";
}
exports.formatFileSize = formatFileSize;
//# sourceMappingURL=tool.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/tool.js
// module id = 55
// module chunks = 0 1